/*
 * @Author: Claude
 * @Date: 2025-11-15
 * @Description: 自定义规则校验
 */
import { t } from '@/utils/helper/intl';

import { ExtendedUploadFile } from '../types';
import { FileUploadRule } from '../types/validator';

/**
 * 执行自定义校验函数
 * @param file - 待校验的文件
 * @param rule - 校验规则
 * @param fileList - 文件列表
 * @returns Promise<string | null> - 错误信息或 null
 */
export const validateCustomRule = async (
  file: File,
  rule: FileUploadRule,
  fileList: ExtendedUploadFile[],
): Promise<string | null> => {
  if (!rule.validator) {
    return null;
  }

  try {
    const result = await rule.validator(file, fileList);
    if (result) {
      return result;
    }
    return null;
  } catch (error) {
    return `${error instanceof Error ? error.message : t('merror.httpError.12301000')}`;
  }
};
